<template>
    <div class="product-wrap d-flex flex-column" :data-id="product.ID" :data-category="category" v-if="show">
        <div class="product-data d-flex">
            <div class="product-img-wrap">
                <div class="product-img" :style="{ 'background-image': `url(${ product.product_image })` }" ><a :href="product.permalink" target="_blank"></a></div>                
            </div>
            <div class="product-text pl-4">
                <h2 class="mb-2"><a :href="product.permalink" target="_blank">{{  product.post_title }}</a></h2>
                <ul class="d-flex product-description">
                    <li><strong>{{ product.kcals }}</strong> Kcals</li>
                    <li><strong>{{ product.protein }}gr </strong> Protein</li>
                    <li><strong>{{ product.carbs }}gr </strong> Carbs</li>
                    <li><strong>{{ (product.price/100).toFixed(2) }} </strong> Price</li>
                </ul>
            </div>
        </div>
        <div class="product-control-row d-flex align-center mt-5 pb-6 mb-6">
            <div class="product-control d-flex row" v-if="!editOrder">
                <div class="btn-update-count minus" @click="updateCount('--', product, category)"><span></span></div>
                <div class="item-count" >{{ product.count >= 1 ?  product.count : 1 }}</div>
                <div class="btn-update-count plus" @click="updateCount('++', product, category)"><span></span></div>
            </div>
            <div class="d-flex align-center btn-change-row">
                <v-btn 
                class="btn-product btn-product-change"
                height='50'
                rounded="10"
                border="2"
                @click="changeProduct(category, product.ID, product.count, dayProducts)"                         
                >Change</v-btn>
            </div>
        </div>       
    </div>
</template>

<script>

export default {
    name: 'itemProduct',
    components: {        
    },
    props: ['product', 'category', 'data', 'dayProducts', 'editOrder'],
    data() {
        return {
            show: true,
            changeMP: 0,
            changeBP: 0,
            changeSP: 0,
            menus: [],    
        }
    },
    computed: { 
        weeklyPlan() {
            return this.$store.getters.weeklyPlan;
        },      
        itemsOrder() {
            return this.$store.getters.itemsOrder;
        },
        mainProducts() {
            return this.$store.getters.getMainProducts;
        },
        breakfastProducts() {
            return this.$store.getters.getBreakfastProducts;
        },
        snacksProducts() {
            return this.$store.getters.getSnacksProducts;
        },
        orderProducts() {
            return this.$store.getters.orderProducts;
        },   
        wizardMenu() {
            return this.$store.getters.wizardMenu;
        }, 
  
    },
    emits: ['open-popup'],
    methods: {
        updateCount(badg,product, category) {
          
            if(badg == '++') {
                ++product.count;
                 if (category == 'main') {
                    this.weeklyPlan.forEach(item => {
                        if (item.view == true) {
                            if (badg == '++') {
                                ++item.countMain;
                            }

                        }
                    });
                }

                if (category == 'breakfast') {
                    this.weeklyPlan.forEach(item => {
                        if (item.view == true) {
                            if (badg == '++') {
                                ++item.countBreakfast;
                            }

                        }
                    });
                }

                if (category == 'snacks') {
                    this.weeklyPlan.forEach(item => {
                        if (item.view == true) {
                            if (badg == '++') {
                                ++item.countSnack;
                            }
                        }
                    });
                }

            }

            if (badg == '--' && product.count > 1) {
                 if (category == 'main') {
                    this.weeklyPlan.forEach(item => {
                        if (item.view == true) {
                            if (badg == '--' && item.countMain > 0) {
                                --item.countMain;
                            }
                        }
                    });
                }

                if (category == 'breakfast') {
                    this.weeklyPlan.forEach(item => {
                        if (item.view == true) {
                            if (badg == '--' && item.countBreakfast > 0) {
                                --item.countBreakfast;
                            }
                        }
                    });
                }

                if (category == 'snacks') {
                    this.weeklyPlan.forEach(item => {
                        if (item.view == true) {
                            if (badg == '--' && item.countSnack > 0) {
                                --item.countSnack;
                            }
                        }
                    });
                }

                --product.count;
            }

            //this.$store.commit('updateCountProduct', product);
        },
        changeProduct(category, productID, count, dayProducts) { 
            
            let popupProduct = { visible: true, category: category, oldproductID: productID, count: count, arrPr: dayProducts };   
            this.$store.commit('setPopupProduct', popupProduct);
            this.$emit('open-popup');           
        },        
    },
    async beforeMount() {

        this.menus = this.$store.getters.getMenus;
        this.changeBP = this.menus[0].count;
        this.changeMP = this.menus[1].count;
        this.changeSP = this.menus[2].count;

    }

}
</script>

<style lang="stylus">
    .btn-change-row {
        gap: .5rem;
        
        @media (max-width: 380px) {
            max-width: calc(100% - .2rem - 175px);
        }
        .v-btn {
            @media (max-width: 480px) {
                max-width: 120px;
                min-width: 120px;
            }
        }
    }

    .btn-product {
        font-family: 'Manrope', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #1D2433;
        text-transform: capitalize;
        letter-spacing: normal;
        border-radius: 10px;

        &-change {
            box-shadow: none;
            border: 2px solid #E1E6EF;
            min-width: 100px;
            
            &.v-btn--disabled {
                opacity: .7!important;  
                cursor: no-drop!important;
                pointer-events: auto;   
            }
        }

        &-delete {
            background: none;
            @media (max-width: 400px) {
                padding: 0;
            }
        }
    }
</style>
<style lang="stylus">

   .product-wrap {
        &:last-child .product-control-row {
            margin-bottom: 0!important;
            padding-bottom: .5rem!important;
            border-bottom: none!important;
        }
    }
    .product-control
        display: grid;
        gap: .5rem;
        width: 185px;
      
        &-row {
            border-bottom: 2px solid #E1E6EF;
        }

        & > div
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border-radius: 10px;
                width: 45px;
                height: 50px;

                span {
                    width: 25.5px;
                    height: 25px;
                    background-size: cover;
                }
                &.minus {
                    span {
                        background: url(/src/assets/images/icons/minus.svg)
                    }
                }
                &.plus {
                    span {
                        background: url(/src/assets/images/icons/plus.svg)
                    }
                }
                &.item-count
                    width: 45px;
                    height: 50px;
                    background: #FFFFFF;
                    border: 2px solid #E1E6EF;                    
                    letter-spacing: -0.02em;
                    color: #201747;
                    font-family: 'Manrope';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 33px;
                &.btn-update-count
                    background: #685BC7;     
                    padding: 10px 16px; 
                    width: 45px;
                    height: 50px;
                    divansition-duration: .4s;
                    cursor: pointer 
                    &:hover
                        background: #50469a;
    #content .product-data,
    .product-data {
        .product-img {
            width: 101.81px;
            height: 98px;
            background-size: cover;
            object-fit: cover;
            background-color: #e1e6ef;
            transition-duration: 2s;
            cursor: pointer;

            &:hover {
                transform: scale(1.4);
            }
            
           &-wrap {
                border-radius: 5px;
                width: 101.81px;
                height: 98px;
                overflow: hidden;
                position: relative;

                a {
                    position: absolute;
                    width: 101.81px;
                    height: 98px;
                }
           } 
        }

        .product-text {
            max-width: calc(100% - 102px);

            h2 {
                font-family: 'Manrope', sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 22px!important;
                line-height: 25px;
                color: #1D2433;

                @media screen and (max-width: 991px) {
                    font-size: 18px!important;
                }

                a:visited,
                a {
                    text-decoration: none;
                    transition-duration: .4s;
                    color: #1D2433;

                    &:hover {
                        color: #2ad2c9;
                    }
                }
            }

            .product-description {
                list-style: none;
                flex-wrap: wrap;             

                li {
                    padding-right: 5px;
                    margin-right: 5px;
                    border-right: 1px solid #1D2433;
                    font-family: 'Manrope';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: .8;
                    white-space: nowrap; 
                    
                    @media screen and (max-width: 991px) {
                        font-size: 12px;
                    }

                    @media (max-width: 500px) {
                        margin-bottom: .5rem;
                    }

                    &:last-child {
                        border-right: none;
                        padding-right: 0;
                        margin-right: 0;
                    }
                }
            }
        }
    }
.btn-product {
    font-family: 'Manrope', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #1D2433;
    text-transform: capitalize;
    letter-spacing: normal;
    border-radius: 10px;

    &-change {
        box-shadow: none;
        border: 2px solid #E1E6EF;
        min-width: 100px;
        
        &.v-btn--disabled {
            opacity: .7!important;  
            cursor: no-drop!important;
            pointer-events: auto;   
        }
    }

}
</style>